<div class="hr-overview-section">
  <div class="hr-overview-heading-wrapper">
    <h2 class="hr-overview-heading">HR Dashboard Overview</h2>
    <p class="hr-overview-subtitle">A clean, modern HR dashboard preview with real-time analytics and seamless workflow visuals.</p>
  </div>
  <div class="hr-overview-centered">
    <div class="hr-curved-bg" aria-hidden="true"></div>

    <div class="hr-overview-card--center">
      <div class="hr-card">
        <img src="images/webps/hr-1.PNG" alt="HR dashboard preview" />
      </div>
    </div>
  </div>
</div>
